import { ResultsTournamentContext } from "@state/context/results";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ResultsTournamentStatisticsButton from "./ResultsTournamentStatisticsButton";
import { ScoreHeaderRenderer } from "./ScoreHeaderRenderer";
import EmptyHeaderSpacesWrapper from "./EmptyHeaderSpacesWrapper";

export default function ResultsTableSubheader() {
	const tournament = useContext(ResultsTournamentContext);
	const translationHook = useTranslation();

	return (
		<thead className="table--results__subheader">
			<tr className="table--results__subheader__row">
				<th
					className="table--results__subheader__data table--results__subheader__data--tournament"
					colSpan={2}
				>
					{tournament.name}
				</th>

				<ResultsTournamentStatisticsButton />

				<ScoreHeaderRenderer />

				<th className="table--results__subheader__data table--results__subheader__data--tip">
					{translationHook.t<string>("RESULTS.RESULT_CONTENT.TIP")}
				</th>

				<th className="table--results__subheader__data table--results__subheader__data--odd">
					{translationHook.t<string>("RESULTS.RESULT_CONTENT.ODD")}
				</th>

				<EmptyHeaderSpacesWrapper />

				<th className="table--results__subheader__data is-empty">
					&nbsp;
				</th>
			</tr>
		</thead>
	);
}
